"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiRequestBuilder = void 0;
const api_request_1 = require("./api-request");
const types_1 = require("../types");
/**
 * Represents a builder for creating API requests.
 * @public
 */
class ApiRequestBuilder {
    /**
     * Creates an instance of ApiRequestBuilder.
     * @param request - The API request object.
     * @param environment - The environment configuration object.
     */
    constructor(request, environment) {
        this.request = request;
        this.environment = environment;
    }
    /**
     * Builds and returns the generated Request object.
     * @returns The generated Request object.
     * @throws Error if the API key is not set.
     */
    build() {
        if (!this.environment.apiKey) {
            throw new Error('API key not set.');
        }
        const adjustedPath = this.request.path.startsWith('/') ? this.request.path : `/${this.request.path}`;
        const apiVersion = this.request.apiVersion || api_request_1.ApiVersion.V1;
        const league = this.request.league == types_1.League.None ? '' : `/${this.request.league}`;
        const newPath = `/football/${apiVersion}/sdk${league}${adjustedPath}`;
        const url = new URL(newPath, this.environment.baseURL);
        const fullUrl = this.request.queryParameters ? `${url.toString()}?${this.request.queryParameters.toString()}` : url;
        const defaultHeaders = {
            'Content-Type': 'application/json',
            'api-key': this.environment.apiKey,
        };
        const headers = this.request.headers ? { ...defaultHeaders, ...this.request.headers } : defaultHeaders;
        const generatedRequest = new Request(fullUrl, {
            method: this.request.method,
            headers,
        });
        return generatedRequest;
    }
}
exports.ApiRequestBuilder = ApiRequestBuilder;
//# sourceMappingURL=request-builder.js.map